<div class="container">
    <p-sidebar
       class="panel"
       [appendTo]="'body'"
       [position]="position"
       [blockScroll]="true"
       (onHide)="clickBackground($event)"
       [(visible)]="visible"
       [showCloseIcon]="closeIcon"
       (visibleChange)="change($event)"
    >
    <app-button class="btn-close" [buttonClass]="'only-icon-light-gray'" [iconDirection]="'left'"
        [icon]="'assets/images/new-design-icons/close-white.svg'" (buttonClick)="change(false)"/>
    <div class="content-panel">
        <div *ngIf="header" class="header-block">
            <h3 class="header">{{ header }}</h3>
        </div>
        <main class="body">
            <ng-container *ngTemplateOutlet="template;"></ng-container>
        </main>
    </div>
    </p-sidebar>
</div>
